<template>
  <router-link
    :to="{ name: 'company' }"
    class="logo-client">
    <div
      class="logo-client__no-logo"
      v-if="!clientLogo"></div>
      <img
        :src="clientLogo"
        v-if="clientLogo"
        class="logo-client__img" />
  </router-link>
</template>

<script>
  import { EventBus, Http } from '@intelipost-js/secure-providers';

  export default {
    name: 'sc-client-logo',
    data() {
      return {
        clientLogo: null,
      };
    },
    methods: {
      getLogoClient() {
        return Http.get('api/v1/client/logo').then((res) => {
          if (res) {
            const { content = null } = res.data || {};
            this.clientLogo = content;
          }
        });
      },
    },
    beforeMount() {
      EventBus.$on('changeLogoClient', () => this.getLogoClient());
      return this.getLogoClient();
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line

  .logo-client{
    display: inline-block;
    border-left: 1px solid $grey-lighter;
    padding-left: 20px;
    height: 40px;
  }
  .logo-client__no-logo{
    background: $white-ter;
    border: 2px dashed $grey-lighter;
    width: 100px;
    height: 30px;
    margin: .25rem 0;
    &:before{
     content: 'Insira seu logotipo';
     text-align: center;
     font-size: 10px;
     color: $grey-lighter;
     display: block;
     margin-top: 6px;
   }
  }
  .logo-client__img{
    height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sc-client-logo/ScClientLogo.vue?7cbc5a8e